import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Converter from './Converter';
import { stockCards } from './StockTable';
import StockThread from './StockThread';
import { priceChart, fmtDate } from './PriceChart';
import { loadMarkets, loadHistory, stocksOf, marketStatus, naira, pct, tone, updatedText, stockHref, ordinal, sectorLabel } from '../util';

/**
 * /markets/{symbol}: one listed company. Price and changes, its place in the market, price history (from the daily
 * closes the market script saves), what its shares cost, others in its sector, and its comment thread (one discussion per company).
 */
export default class StockPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.symbol = String(m.route.param('symbol') || '').toUpperCase();
    this.markets = null;
    this.history = null;
    this.error = null;
    loadMarkets().then(d => this.markets = d).catch(() => this.error = 'Could not load market data. Please try again shortly.').then(() => {
      const s = this.stock();
      if (s) app.setTitle(s.name + ' (' + s.symbol + ') share price today');
      m.redraw();
    });
    loadHistory(this.symbol).then(p => {
      this.history = p;
      m.redraw();
    });
  }
  stock() {
    return stocksOf(this.markets).find(s => s.symbol.toUpperCase() === this.symbol) || null;
  }
  view() {
    // phones: the company's symbol in the header bar (Flarum places .App-titleControl there)
    const back = [m('h4.App-titleControl.App-titleControl--text', this.symbol || 'Markets'), m(Link, {
      className: 'VouchaMk-back',
      href: app.route('voucha.markets.ngx')
    }, '← NGX')];
    if (this.error) return m('.VouchaMarkets', [back, m('.VouchaMarkets-error', this.error)]);
    if (!this.markets) return m('.VouchaMarkets', [back, m('.VouchaMarkets-loading', 'Loading…')]);
    const stocks = stocksOf(this.markets);
    const s = this.stock();
    if (!s) return m('.VouchaMarkets', [back, m('section.VouchaMarkets-section', [m('h1', this.symbol), m('p', 'This company is not listed on the Nigerian Exchange, or has no price today.')])]);
    const rank = stocks.indexOf(s) + 1;
    const status = marketStatus(this.markets);
    const sector = sectorLabel(s.sector);
    const peers = stocks.filter(p => p !== s && sectorLabel(p.sector) === sector).slice(0, 8);
    return m('.VouchaMarkets.VouchaStock', [back, m('header.VouchaStock-head', [m('h1', [s.name, ' ', m('span.VouchaStock-sym', s.symbol)]), m('p.helpText', [s.sector ? sector + ' · ' : '', 'Nigerian Exchange (NGX)']), m('.VouchaStock-price', [m('strong', naira(s.current_price)), m('span', {
      className: tone(s.change_percent)
    }, pct(s.change_percent) + ' today')]), m('.VouchaMarkets-updated', [status ? m('span.VouchaMarkets-statusBadge', {
      className: 'is-' + status.toLowerCase().replace(/\s+/g, '-')
    }, 'Market ' + status.toLowerCase()) : null, m('span', updatedText(this.markets.stocks && this.markets.stocks.updated_at))])]), m('section.VouchaMk-glance', [this.fact('7 days', pct(s.pct_change_7d), tone(s.pct_change_7d)), this.fact('Market value', naira(s.market_cap, true)), this.fact('Rank by value', ordinal(rank) + ' of ' + stocks.length), this.fact('Sector', sector)]), this.historySection(), m(Converter, {
      markets: this.markets,
      symbol: s.symbol
    }), m(StockThread, {
      symbol: s.symbol,
      name: s.name
    }), peers.length ? m('section.VouchaMarkets-section', [m('h2', 'Others in ' + (s.sector ? sector : 'this sector')), stockCards(peers), m('table.VouchaMarkets-table.VouchaMk-stocks', m('thead', m('tr', [m('th', 'Company'), m('th', 'Price'), m('th', 'Today'), m('th', 'Market value')])), m('tbody', peers.map(p => m('tr', {
      key: p.symbol
    }, [m('td.VouchaMk-co', m(Link, {
      href: stockHref(p.symbol)
    }, [m('strong', p.symbol), m('span', p.name)])), m('td', {
      'data-label': 'Price'
    }, naira(p.current_price)), m('td', {
      'data-label': 'Today',
      className: tone(p.change_percent)
    }, pct(p.change_percent)), m('td', {
      'data-label': 'Market value'
    }, naira(p.market_cap, true))]))))]) : null, m('p.VouchaMk-source', 'Prices from the Nigerian Exchange (via NGXPulse), updated every 30 minutes while the market is open. Not investment advice.')]);
  }
  fact(label, value, cls) {
    return m('.VouchaMarkets-summaryCard', [m('span', label), m('strong', {
      className: cls || ''
    }, value)]);
  }
  historySection() {
    const p = this.history;
    if (!p || p.length < 2) return null; // no history yet: no section
    const first = p[0];
    const last = p[p.length - 1];
    const change = (last.close - first.close) / first.close * 100;
    return m('section.VouchaMarkets-section', [m('.VouchaMk-sectionHead', [m('h2', 'Price history'), m('span', {
      className: 'VouchaMk-histChange ' + tone(change)
    }, pct(change) + ' since ' + fmtDate(first.date))]), m('.VouchaMk-chartWrap', m.trust(priceChart(p))), m('.VouchaMk-chartAxis', [m('span', fmtDate(first.date)), m('span', fmtDate(last.date))])]);
  }
}
flarum.reg.add('voucha-markets', 'forum/components/StockPage', StockPage);